export const buildDataCorrectionHeading = (title) => ({
  type: 'heading',
  title,
});

export const buildDataCorrectionNestedFields = (path, fields) => ({
  type: 'nestedFields',
  path,
  fields,
});

export const buildDataCorrectionFlatFields = (fields) => ({
  type: 'flatFields',
  fields,
});

export const buildDataCorrectionListSection = ({
  title,
  path,
  nameKey,
  labelPrefix,
}) => ({
  type: 'list',
  title,
  path,
  nameKey,
  labelPrefix,
});

export const buildPersonNameFields = (prefix = '') => [
  { key: 'firstName', label: `${prefix}First Name`.trim() },
  { key: 'middleName', label: `${prefix}Middle Name`.trim() },
  { key: 'lastName', label: `${prefix}Last Name`.trim() },
  { key: 'suffix', label: 'Suffix' },
  { key: 'aliases', label: 'Aliases' },
];

export const buildInitialMiddleLastFields = (prefix) => [
  { key: 'firstName', label: `${prefix} First Name`.trim() },
  { key: 'middleInitial', label: `${prefix} Middle Initial`.trim() },
  { key: 'lastName', label: `${prefix} Last Name`.trim() },
  { key: 'aliases', label: 'Aliases' },
];

export const buildListAfterReason = ({ title, path, nameKey, labelPrefix }) => ({
  title,
  path,
  nameKey,
  labelPrefix,
});
